import { Loader2 } from "lucide-react";

export function Card({ title, right, children, className = "", testid }) {
  return (
    <section data-testid={testid} className={`rounded-lg border border-border bg-card ${className}`}>
      {(title || right) && (
        <header className="flex items-center justify-between gap-3 border-b border-border px-4 py-2.5">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">{title}</h3>
          {right}
        </header>
      )}
      <div className="p-4">{children}</div>
    </section>
  );
}

export function Kpi({ label, value, sub, testid, toneClass = "" }) {
  return (
    <div data-testid={testid} className="rounded-lg border border-border bg-card px-4 py-3 transition-colors duration-200 hover:border-primary/40">
      <div className="text-[10.5px] uppercase tracking-[0.14em] text-muted-foreground">{label}</div>
      <div className={`num mt-1 text-xl font-semibold ${toneClass}`}>{value}</div>
      {sub && <div className="mt-0.5 text-[11px] text-muted-foreground">{sub}</div>}
    </div>
  );
}

const PILL = {
  Active: "bg-emerald-500/15 text-emerald-400", ACTIVE: "bg-emerald-500/15 text-emerald-400", OK: "bg-emerald-500/15 text-emerald-400",
  COMPLETE: "bg-emerald-500/15 text-emerald-400", Created: "bg-emerald-500/15 text-emerald-400", EXECUTED: "bg-emerald-500/15 text-emerald-400",
  SENT: "bg-emerald-500/15 text-emerald-400", normal: "bg-emerald-500/15 text-emerald-400", LIVE: "bg-emerald-500/15 text-emerald-400", OPEN: "bg-sky-500/15 text-sky-400",
  PENDING: "bg-amber-500/15 text-amber-400", Pending: "bg-amber-500/15 text-amber-400", TRIGGER_PENDING: "bg-amber-500/15 text-amber-400",
  warning: "bg-amber-500/15 text-amber-400", "Trading blocked": "bg-amber-500/15 text-amber-400", REVIEWED: "bg-amber-500/15 text-amber-400",
  INVITED: "bg-amber-500/15 text-amber-400", SCHEDULED: "bg-amber-500/15 text-amber-400", DELAYED: "bg-amber-500/15 text-amber-400",
  REJECTED: "bg-red-500/15 text-red-400", Failed: "bg-red-500/15 text-red-400", FAILED: "bg-red-500/15 text-red-400", critical: "bg-red-500/15 text-red-400",
  Suspended: "bg-red-500/15 text-red-400", DISABLED: "bg-red-500/15 text-red-400", Closed: "bg-zinc-500/20 text-zinc-400", CANCELLED: "bg-zinc-500/20 text-zinc-400",
  CLOSED: "bg-zinc-500/20 text-zinc-400", REVERSED: "bg-fuchsia-500/15 text-fuchsia-300", UNAVAILABLE: "bg-red-500/15 text-red-400",
};

export function Pill({ value, testid }) {
  if (value == null || value === "") return <span className="text-muted-foreground">—</span>;
  return <span data-testid={testid} className={`inline-flex rounded px-1.5 py-0.5 text-[10.5px] font-semibold ${PILL[value] || "bg-secondary text-foreground/80"}`}>{String(value).replace(/_/g, " ")}</span>;
}

export function Spinner({ className = "" }) {
  return <Loader2 className={`h-4 w-4 animate-spin text-primary ${className}`} />;
}

export function PageHead({ title, sub, children }) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h1 data-testid="page-title" className="font-display text-2xl font-bold tracking-tight">{title}</h1>
        {sub && <p className="mt-1 text-sm text-muted-foreground">{sub}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
    </div>
  );
}

export function KV({ rows }) {
  return (
    <dl className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm sm:grid-cols-3">
      {rows.map(([k, v]) => (
        <div key={k} className="min-w-0">
          <dt className="text-[10.5px] uppercase tracking-wider text-muted-foreground">{k}</dt>
          <dd className="num truncate">{v ?? "—"}</dd>
        </div>
      ))}
    </dl>
  );
}
